/**
 * Minimal CSV builder + browser download helper. No parsing here - only ever used to build a
 * simple export (roster template) client-side, so a naive quote-escaping join is enough.
 */
// CSV/formula injection (CWE-1236): a value starting with =/+/-/@ (or a tab/CR, which Excel treats
// the same way) is evaluated as a formula when the file is opened in Excel/LibreOffice - relevant
// here because this builds a roster export straight from a student's own (self-editable) name. A
// leading apostrophe forces the cell to be read as plain text without changing what's displayed.
const neutralizeFormulaPrefix = (stringValue) => (/^[=+\-@\t\r]/.test(stringValue) ? `'${stringValue}` : stringValue)

const escapeCsvValue = (value) => {
  const stringValue = neutralizeFormulaPrefix(value === null || value === undefined ? '' : String(value))
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`
  }
  return stringValue
}

export const buildCsv = (headers, rows) => {
  const lines = [headers.map(escapeCsvValue).join(',')]
  rows.forEach(row => {
    lines.push(headers.map(header => escapeCsvValue(row[header])).join(','))
  })
  return lines.join('\n')
}

/**
 * Same shape as buildCsv, but semicolon-delimited with a UTF-8 BOM prefix - the exact format
 * `course-generator` (see web-api-colegios's `_toLegacyCsv`) already reads. Kept separate from
 * buildCsv rather than parameterizing the delimiter: this one exists specifically to match a
 * third-party file format, not as a general-purpose option.
 */
const escapeLegacyCsvValue = (value) => {
  const stringValue = neutralizeFormulaPrefix(value === null || value === undefined ? '' : String(value))
  if (/[;"\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`
  }
  return stringValue
}

export const buildLegacyCsv = (headers, rows) => {
  const lines = [headers.map(escapeLegacyCsvValue).join(';')]
  rows.forEach(row => {
    lines.push(headers.map(header => escapeLegacyCsvValue(row[header])).join(';'))
  })
  return '﻿' + lines.join('\n')
}

export const downloadCsv = (filename, csvContent) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
